const APP_ROUTE = {
  // 登录
  LOGIN: '/login',
  // 忘记密码
  FORGOT_PASSWORD: '/forgot-password',
  // 主页
  HOME: '/schedule',
  // 切换企业
  SWICH: '/switch',
  // 无企业
  NONE: '/none',
  // 会议详情
  DETAILS: '/details/:id',
  // 会议详情
  ORDER_MEETING: '/order-meeting',
  // 修改会议详情
  EDIT: '/edit/:id',
  // 预约
  BOOKING: '/booking',
  // 受邀
  INVITED: '/invited/:id',
  // Teamwork页
  TEAMWORKHOME: '/teamwork',
  // 通讯录
  CONTACT: '/contact',
  // 会议安排
  SCHEDULE: '/meeting_days',
  //
  INDEX: '/',
  // 协同通讯录
  CO_CONTACT: '/co-contact',
  // 无企业
  NOCOMPANY: '/no-company',
  // 会议室详情
  ROOM_DETAIL: '/room-detail/:id',
  // 帮助
  HELP: '/help',
  // 企微登录
  WorkWeChatLOGIN: '/WorkWeChatLogin',
  // 审批中心
  APPROVALCENTER: '/approval-center',
  // 发起的审批详情
  INITIATEDAPPROVALDETAIL: '/initiated-approval-detail/:id',
  // 收到的审批详情
  RECEIVEDAPPROVALDETAIL: '/received-approval-detail/:id',
  // 会议自动提前结束
  EARLY_END: '/early-end/:id',
  // 第三方路由下发页
  TRANSFER: '/transfer'
};

export default APP_ROUTE;
